import * as angular from 'angular';
import { arraysEqual } from 'data/array';
import { debounce } from 'data/function';
import { RulesConstants } from '../rules/RulesConstants';
import { ToastType } from 'modules/application/misc/ToastService';
export class ConditionItemController {
    static $inject = ['SegmentService', '$translate', 'BlipToastService'];
    constructor(SegmentService, $translate, BlipToastService) {
        'ngInject';
        this.SegmentService = SegmentService;
        this.$translate = $translate;
        this.BlipToastService = BlipToastService;
        this.onChangeProperty = async (event) => {
            if (!this.canEditRule) {
                this.noPermissionValidate();
                return;
            }
            if (event?.detail?.value && this.condition.property !== event.detail.value) {
                this.condition.property = event.detail.value;
                this.tryEdit();
            }
        };
        this.onChangeExtrasProperty = async (event) => {
            if (!this.canEditRule) {
                this.noPermissionValidate();
                return;
            }
            this.condition.extrasProperty = event.detail.value ?? '';
            if (this.condition.extrasProperty) {
                this.tryEdit();
            }
        };
        this.onChangeRelation = async (event) => {
            if (!this.canEditRule) {
                this.noPermissionValidate();
                return;
            }
            if (!event || this.condition.relation === event.detail?.value) {
                return;
            }
            else {
                this.condition.relation = event.detail.value;
            }
            this.tryEdit();
        };
        this.onChangeValues = async (event) => {
            if (!this.canEditRule) {
                this.noPermissionValidate();
                return;
            }
            if (!event || arraysEqual(this.condition.values, event.detail?.data)) {
                return;
            }
            else {
                this.condition.values = event.detail?.data || [];
                this.valuesEmpty = this.condition.values.length === 0;
            }
            this.tryEdit();
            if (this.valuesEmpty) {
                await this.showToast('conditions.cannotSaveEmptyValues', ToastType.Warning);
                return;
            }
        };
        this.tryEdit = async () => {
            try {
                if (this.onEdit) {
                    await this.onEdit({ $condition: this.condition });
                    if (this.condition.property?.includes(RulesConstants.EXTRAS)) {
                        this.condition.property = RulesConstants.CONTACT_EXTRAS;
                    }
                }
            }
            catch (e) {
                await this.showToast('conditions.warning', ToastType.Warning);
            }
        };
        this.noPermissionValidate = async () => {
            this.condition = angular.copy(this.data);
        };
        this.onChangeExtrasPropertyDebounced = debounce(this.onChangeExtrasProperty, 250);
    }
    async $onInit() {
        this.condition = angular.copy(this.data);
    }
    async onDeleteCondition() {
        if (!this.canEditRule) {
            return;
        }
        try {
            this.onDelete({ $conditionIndex: this.conditionIndex });
        }
        catch (e) {
            await this.showToast('conditions.warning', ToastType.Warning);
        }
    }
    async showToast(messageReference, type) {
        const msg = await this.$translate(messageReference);
        const toastOptions = { msg };
        await this.BlipToastService.show(type, toastOptions);
    }
}
ConditionItemController.$inject = ['SegmentService', '$translate', 'BlipToastService'];
